// External imports
import React from 'react';
import { Button, FormControl } from '@material-ui/core';
// Internal imports
import logoplaceholder from '~/images/logoplaceholder.png';
import OfficeRadioList from '#/Auth/OfficeRadioList.jsx';
import ClickableTypography from '#/Common/ClickableTypography.jsx';
import { AUTH_FLOW_SESSION_KEYS } from '~/app/constants';
import WebHelpers from '~/app/webHelpers.js';
import { useSetState } from '~/app/Utility/customHooks';
// Redux imports
import { store } from '~/app/redux/index';
import { actions as appActions } from '~/app/redux/modules/app';

// TODO - move styles to separate file
const styles = {
  labels: {
    height: '16px',
    width: '95px',
    color: '#354052',
    fontSize: '14px',
    lineHeight: '16px',
  },
  formStyle: {
    marginLeft: '17em',
    marginTop: '3em',
  },
  back: {
    display: 'inline',
    height: '16px',
    width: '31px',
    color: '#0077FF',
    fontSize: '14px',
    lineHeight: '16px',
    marginRight: '3em',
  },
  continue: {
    height: '35px',
    width: '102px',
    borderRadius: '4px',
    backgroundColor: '#0077FF',
  },
  topPadding: {
    padding: '1em 1em 3em 1em',
  },
  get headerLabels() {
    return {
      ...this.labels,
      fontWeight: '500',
      fontSize: '21px',
      letterSpacing: '0.14px',
      lineHeight: '24px',
    };
  },
  get smallLabels() {
    return {
      ...this.labels,
      fontSize: '12px',
      lineHeight: '14px',
      letterSpacing: '0.08px',
      color: '#637280',
    };
  },
};

const SelectOffice = ({ onClickContinue }) => {
  const payload = WebHelpers.getJWTPayload();
  const [state, setState] = useSetState({
    officeID: 0,
  });

  const clearAuthAndLogout = () => {
    // Back from pre-auth office selection must clear persisted tokens first,
    // otherwise Login mount-time validation can immediately re-enter this flow.
    sessionStorage.removeItem(AUTH_FLOW_SESSION_KEYS.SSO_PICK_OFFICE_COMPLETION_PENDING);
    WebHelpers.cleanupSession();
    WebHelpers.cleanupLocalStorage();
    store.dispatch(appActions.onLogout());
  };

  const selectOfficeID = e => {
    setState({
      officeID: e,
    });
  };

  const finalLogo = localStorage.getItem('finalLogo');

  return (
    <div className="container-fluid" id="officeListContainer">
      <div className="container" style={{ paddingTop: '3em', paddingLeft: '5em' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <img src={finalLogo || logoplaceholder} className="logoCrosslink" />
        </div>
        <span style={styles.headerLabels}>Multiple offices are linked to your login</span>
        <div>
          <span style={styles.labels}>Select default office</span>
        </div>
        <OfficeRadioList onOfficeChange={selectOfficeID} />
        <FormControl required>
          <div id="selectOfficeButtonDiv" style={styles.formStyle}>
            <ClickableTypography
              id="typBackFromOfficeSelect"
              style={styles.back}
              onClick={clearAuthAndLogout}
              color="primary"
            >
              Back
            </ClickableTypography>
            <Button
              id="btnSubmitOfficeSelection"
              style={styles.continue}
              variant="contained"
              type="submit"
              color="primary"
              onClick={() => {
                const offices = payload?.offices ?? [];
                const selectedOffice = offices.find(
                  o => String(o.office_id) === String(state.officeID),
                );

                if (!selectedOffice) {
                  alert('Critical error, cannot find selected office');
                  clearAuthAndLogout();
                  return;
                }

                onClickContinue(selectedOffice.office_id, payload?.season);
              }}
            >
              Continue
            </Button>
          </div>
        </FormControl>
      </div>
    </div>
  );
};

export default SelectOffice;
